export default function IconEmail() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      data-name="Layer 2"
      viewBox="0 0 20 16.4"
    >
      <path
        d="M19 2.8c0-.99-.81-1.8-1.8-1.8H2.8C1.81 1 1 1.81 1 2.8m18 0v10.8c0 .99-.81 1.8-1.8 1.8H2.8c-.99 0-1.8-.81-1.8-1.8V2.8m18 0-9 6.3-9-6.3"
        data-name="Layer 1"
        style={{
          fill: "none",
          stroke: "var(--color-primary)",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: 2,
        }}
      />
    </svg>
  );
}
